import { Button, Divider, Group, Stack } from "@mantine/core";
import { useState } from "react";
import { useLanguage } from "../../../../../stores/LanguageStore";
import { IconUsersMinus } from "@tabler/icons-react";
import { transformFilterToServer } from "../../../../../functions/utilFunctions";
import { blacklistList } from "../../../../../api/ContactAPI";
import { notifications } from "@mantine/notifications";
import DatafieldsSelector from "../../../../../components/Selectors/DatafieldsSelector";
import CreatableBlacklistSelector from "../../../../../components/Selectors/CreatableBlacklistSelector";
import CronSettings from "../crons/CronSettings";

const BlacklistDestination = ({
  id,
  type,
  isGlobal,
  handleClose,
  onFinish,
  selectedIds,
  filter,
}) => {
  const lang = useLanguage((s) => s.language);
  const [list, setList] = useState(null);
  const [datafieldIds, setDatafieldsIds] = useState([1, 20]);

  const [loading, setLoading] = useState(false);

  const main = () => {
    const data = {
      id,
      blacklist_id: list?.id,
      ids: selectedIds,
      datafield_ids: datafieldIds,
      contacts_selection:
        type === "all" && !isGlobal
          ? undefined
          : {
              contact_ids:
                type === "selection_inverse" ? [] : selectedIds || [],
              excluded_contact_ids:
                type === "selection_inverse" ? selectedIds : [],
              filter:
                type === "filter" || type === "all"
                  ? transformFilterToServer(filter)
                  : { mode: "or", values: [] },
            },
    };

    setLoading(true);
    blacklistList(data)
      .then((res) => {
        onFinish?.(type);
        notifications.show({
          message: lang.contact_lists.to_blacklist.success,
          color: "tertiary.8",
        });
        handleClose();
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <Stack w={300}>
      <Stack gap={16}>
        {(type === "all" || type === "filter") && (
          <>
            <CronSettings
              isBlacklist
              defaultFilter={
                type === "filter" ? transformFilterToServer(filter) : undefined
              }
            />

            <Divider />
          </>
        )}

        <CreatableBlacklistSelector
          value={list}
          setValue={setList}
          label={lang.targeting_linkedin_google.select_blacklist}
          placeholder={lang.contact_lists.create.dialog.desc}
          w={"100%"}
          required
          description={" "}
          size="sm"
          comboboxProps={{
            zIndex: 1700,
            withinPortal: false,
          }}
        />

        <DatafieldsSelector
          label={lang.contact_lists.to_blacklist.which_columns}
          placeholder={lang.contact_lists.to_blacklist.columns}
          values={datafieldIds}
          onChange={(v) => setDatafieldsIds(v.map((x) => x.id))}
          zIndex={1700}
          withinPortal={false}
        />
      </Stack>
      <Group justify="end">
        <Button
          leftSection={<IconUsersMinus size={16} />}
          onClick={main}
          loading={loading}
          color="red"
          disabled={!list || datafieldIds.length === 0}
        >
          {lang.contact_lists.to_blacklist.submit_button}
        </Button>
      </Group>
    </Stack>
  );
};

export default BlacklistDestination;
